export default function Hero() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const img = e.currentTarget;
    img.style.display = 'none';
    const container = img.closest('.img-wrap') as HTMLElement | null;
    if (container) container.style.display = 'none';
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[720px] flex items-center bg-background-50 overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 lg:px-10 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full text-xs md:text-sm font-medium bg-primary-50 text-primary-600 border border-primary-200/60 mb-5 whitespace-nowrap">
              热门话题 · 每日更新 · 海量片库
            </span>

            <h1 className="text-[28px] md:text-[44px] lg:text-[52px] font-heading font-bold text-foreground-950 leading-tight mb-3">
              八戒影视
              <span className="block text-xl md:text-2xl lg:text-3xl font-sans font-medium text-foreground-500 mt-2">
                高清电影电视剧免费在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-primary-500 font-heading font-semibold mb-5">
              畅享全集 · 秒速加载 · 不缓冲不卡顿
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[560px] mx-auto lg:mx-0 mb-8">
              八戒影视网汇聚海量高清电影、热播电视剧、热门综艺和人气动漫资源，每日同步更新最新剧集。
              无需注册付费，打开即看，全站采用高速CDN加速技术，确保播放流畅不缓冲，
              为您带来极致的在线观影体验。无论是最新院线大片还是经典怀旧剧集，这里都能找到。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">20000+</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">影视资源</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-500">每日更新</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">同步追剧</p>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-500">秒速加载</p>
                <p className="text-xs md:text-sm text-foreground-500 mt-1">CDN加速</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleNav('#topics')}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-sm transition-colors whitespace-nowrap cursor-pointer"
              >
                立即探索热门
              </button>
              <button
                onClick={() => handleNav('#updates')}
                className="w-full sm:w-auto px-8 py-3 bg-background-100 hover:bg-background-200 text-foreground-700 font-medium rounded-lg text-sm border border-background-300/60 transition-colors whitespace-nowrap cursor-pointer"
              >
                查看最新更新
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="img-wrap relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20composition%20with%20warm%20golden%20amber%20and%20deep%20coral%20red%20tones%2C%20flowing%20film%20strips%20and%20soft%20bokeh%20lights%2C%20modern%20entertainment%20atmosphere%2C%20dark%20gradient%20background%20with%20subtle%20texture%2C%20professional%20movie%20theater%20ambiance%2C%20dramatic%20lighting%20with%20warm%20highlights%2C%20elegant%20minimal%20design&width=800&height=600&seq=hero-bajie-01&orientation=landscape"
                alt="八戒影视 - 高清电影电视剧免费在线观看平台视觉图"
                className="absolute inset-0 w-full h-full object-cover"
                width="800"
                height="600"
                onError={handleImgError}
              />
              <div className="absolute bottom-3 right-3 bg-background-50/90 backdrop-blur-sm rounded-lg px-4 py-2 flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></span>
                <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">海量片源实时更新中</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}